import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import BackendApiClient from '../../services/api/BackendApiClient';

export interface FeaturedPost {
  id: number;
  title: string;
  description?: string;
  button_text?: string;
  button_url?: string;
  image?: string;
}

interface GetFeaturedPostsDto {
  franchiseId: number;
}

export const featuredPostsApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'featuredPostsApiSlice',
  endpoints: (build) => ({
    getFeaturedPosts: build.query<FeaturedPost[], GetFeaturedPostsDto>({
      queryFn: ({ franchiseId }) =>
        BackendApiClient.request({
          method: 'GET',
          url: `/franchises/${franchiseId}/featured-posts`,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
  }),
});

export const { useGetFeaturedPostsQuery } = featuredPostsApiSlice;
